import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { Observable } from 'rxjs';
import { filter, flatMap, take, timeout } from 'rxjs/operators';
import isSupportedLanguage from './isSupportedLanguage';
import mapMuxOutputToAutoCompletionItems from './mapMuxOutputToAutoCompletionItems';
const DEFAULT_TIMEOUT = 5000;
const isCodeCompletionOutput = output => {
  return output.type === 'code-completion';
};
const flattenSessionOutputs = output => {
  if (Array.isArray(output)) {
    return Observable.of(...output);
  }
  return Observable.of(output);
};
const createMultiplexerAutoCompletionProvider = _ref => {
  let {
    exerciseDetails,
    multiplexerClient,
    timeoutInMs = DEFAULT_TIMEOUT
  } = _ref;
  return {
    provideCompletionItems: _ref2 => {
      let {
        wordAtPosition: word
      } = _ref2;
      if (!isSupportedLanguage(multiplexerClient.options.language)) {
        return Promise.resolve([]);
      }
      const autoCompletionPromise = multiplexerClient.output$.pipe(flatMap(flattenSessionOutputs), filter(isCodeCompletionOutput), take(1), timeout(timeoutInMs)).toPromise().then(mapMuxOutputToAutoCompletionItems(multiplexerClient.options.language)).catch(() => {
        return [];
      });
      multiplexerClient.input(_objectSpread({
        autoComp: word.word,
        code: '',
        command: 'code_completion',
        cursorPos: word.endColumn
      }, exerciseDetails));
      return autoCompletionPromise;
    }
  };
};
export default createMultiplexerAutoCompletionProvider;